import React, { MouseEventHandler } from "react";
import classnames from "classnames";

export type ModalActionsProps = {
  closeModal?: MouseEventHandler<HTMLButtonElement>;
  submitText?: string;
  submit?: MouseEventHandler<HTMLButtonElement>;
  modalSubmitActionClassName?: string;
  submitDisabled?: boolean;
};

function ModalActions({
  closeModal,
  submitText,
  submit,
  modalSubmitActionClassName,
  submitDisabled = false,
}: ModalActionsProps) {
  return (
    <div className="form-actions modal-footer">
      <button
        onClick={closeModal}
        className="btn btn-link"
        type="button"
        data-bs-dismiss="modal"
      >
        {I18n.t("js.cancel")}
      </button>
      <button
        onClick={submit}
        type="submit"
        disabled={submitDisabled}
        className={classnames("btn btn-primary", modalSubmitActionClassName)}
      >
        {submitText ? I18n.t(submitText) : ""}
      </button>
    </div>
  );
}

export default ModalActions;
